import { TextBase, TextLargeParagraph } from '@carboncopyco/ui';
import type React from 'react';

interface EntitySelectCardProps {
  illustration: React.ReactNode;
  title: string;
  description: string;
}
export const EntitySelectCard = ({
  illustration,
  title,
  description,
}: EntitySelectCardProps) => {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      {illustration}
      <div className="pt-3 pb-2">
        <TextLargeParagraph
          label={title}
          color="text-ds-natural-600"
        />
      </div>
      <TextBase
        label={description}
        color="text-ds-natural-400"
      />
    </div>
  );
};
